import { useAxios } from 'src/hooks/use-axios';
import { ExchangeRate } from 'src/types/remit-reporting';

export function useExchangeRate() {
  const exchangeRate = useAxios(
    (axios, signal, currency: string) =>
      axios.request<ExchangeRate>({
        signal,
        url: `${PRISMA_CONFIG.remitReporting}/api/platform/exchange-rate`,
        params: { currency },
        method: 'GET',
      }),
    {
      neededOnPageLoad: false,
    }
  );

  return exchangeRate;
}
